import React from 'react';
import './StockPage.css';

const StockPage = ({ onNavigate }) => (
  <div className="stock-hub page-bleed">
    <h1 className="stock-hub-title">Stock management</h1>
    <p className="stock-hub-lead">Jump to inventory tasks. All lists use live data from the server.</p>
    <div className="stock-hub-actions">
      <button type="button" className="stock-hub-btn stock-hub-btn--primary" onClick={() => onNavigate?.('stock-add')}>
        Add product
      </button>
      <button type="button" className="stock-hub-btn" onClick={() => onNavigate?.('stock-list')}>
        Product list
      </button>
      <button type="button" className="stock-hub-btn" onClick={() => onNavigate?.('stock-alerts')}>
        Low stock alerts
      </button>
    </div>
  </div>
);

export default StockPage;
